export const NOTIFICATIONSDATA = [
    {
        id:0,
        notiNotRead:true,
        notiType: 'Workflow Created',
        notiDesc: 'New workflow has been created',
        startDate:'04:20 AM',
        endDate:'19 Oct, 2023',
        notitypeName:'Workflow Name:',
        notitypeDesc:'Workflow Description:',
        notitypeNameGot:'UK Workflow',
        notitypeDescGot:'Generic Workflow',
        actionType:'Created By:',
        actionRole:'Manager',
        actionTypeBy:'John Doe',
    },
    {
        id:1,
        notiNotRead:true,
        notiType: 'Role Added',
        notiDesc: 'New role has been created',
        startDate:'04:20 AM',
        endDate:'19 Oct, 2023',
        notitypeName:'Role Name:',
        notitypeDesc:'Role Description:',
        notitypeNameGot:'Manager ',
        notitypeDescGot:'Lorem ipsum dolor sit amet consectetur.',
        actionType:'Created By:',
        actionRole:'Admin',
        actionTypeBy:'Jacob Gill',
    },
    {
        id:2,
        notiNotRead:false,
        notiType: 'User Added',
        notiDesc: 'New user has been added',
        startDate:'04:20 AM',
        endDate:'19 Oct, 2023',
        notitypeName:'User Name:',
        notitypeDesc:'User Role:',
        notitypeNameGot:'Clarke Watson',
        notitypeDescGot:'Manager',
        actionType:'Created By:',
        actionRole:'Manager',
        actionTypeBy:'John Doe',
    },
    {
        id:3,
        notiNotRead:false,
        notiType: 'User Details Updated',
        notiDesc: 'User Details has been updated',
        startDate:'04:20 AM',
        endDate:'19 Oct, 2023',
        notitypeName:'User Name:',
        notitypeDesc:'User Role:',
        notitypeNameGot:'Clarke Watson',
        notitypeDescGot:'Manager',
        actionType:'Updated By:',
        actionRole:'Manager',
        actionTypeBy:'John Doe',
    },
    {
        id:4,
        notiNotRead:false,
        notiType: 'Email Composed',
        notiDesc: 'New email has been sent',
        startDate:'04:20 AM',
        endDate:'19 Oct, 2023',
        notitypeName:'Invoice Id:  ',
        notitypeDesc:'Client Name:',
        notitypeNameGot:'1234 ',
        notitypeDescGot:'Jacob Bills',
        actionType:'Composed By:',
        actionRole:'Manager',
        actionTypeBy:'Jacob Gill',
    },
    {
        id:5,
        notiNotRead:false,
        notiType: 'User Deleted',
        notiDesc: 'User has been deleted',
        startDate:'04:20 AM',
        endDate:'19 Oct, 2023',
        notitypeName:'User Name:',
        notitypeDesc:'User Role:',
        notitypeNameGot:'Clarke Watson',
        notitypeDescGot:'Manager',
        actionType:'Deleted By:',
        actionRole:'Admin',
        actionTypeBy:'John Doe',
    },
    {
        id:6,
        notiNotRead:false,
        notiType: 'Role Deleted',
        notiDesc: 'Role has been deleted',
        startDate:'04:20 AM',
        endDate:'19 Oct, 2023',
        notitypeName:'Role Name:',
        notitypeDesc:'Role Description:',
        notitypeNameGot:'Manager ',
        notitypeDescGot:'Lorem ipsum dolor sit amet consectetur.',
        actionType:'Created By:',
        actionRole:'Admin',
        actionTypeBy:'Jacob Gill',
    },
    {
        id:7,
        notiNotRead:false,
        notiType: 'Note Added',
        notiDesc: 'New Note has been created',
        startDate:'04:20 AM',
        endDate:'19 Oct, 2023',
        notitypeName:'Invoice Id',
        furtherDetailNotitypeName:'Client Name: John Doe ',
        notitypeDesc:'Note Description:',
        notitypeNameGot:'1234 ',
        notitypeDescGot:'Lorem ipsum dolor sit amet consectetur. Purus turpis leo sollicitudin vulputate imperdiet bibendum tempor .',
        actionType:'Created By:',
        actionRole:'Manager',
        actionTypeBy:'Clarke  Bill',
    },
    {
        id:8,
        notiNotRead:false,
        notiType: 'Access Rights Updated',
        notiDesc: 'Role’s Rights have been updated',
        startDate:'04:20 AM',
        endDate:'19 Oct, 2023',
        notitypeName:'Role Name:',
        notitypeDesc:'Role Description:',
        notitypeNameGot:'Manager ',
        notitypeDescGot:'Lorem ipsum dolor sit amet consectetur.',
        actionType:'Updated By:',
        actionRole:'Admin',
        actionTypeBy:'Clarke  Bill',
    },
    {
        id:9,
        notiNotRead:false,
        notiType: 'Collection Status Changed',
        notiDesc: 'Collection status has been changed',
        startDate:'04:20 AM',
        endDate:'19 Oct, 2023',
        notitypeName:'Client Name:',
        notitypeDesc:'Collection Status:',
        notitypeNameGot:'Clarke Watson',
        notitypeDescGot:'Paused',
        actionType:'Updated By:',
        actionRole:'Manager',
        actionTypeBy:'John Doe',
    },
    {
        id:10,
        notiNotRead:false,
        notiType: 'Workflow Assigned',
        notiDesc: 'New workflow has been assigned',
        startDate:'04:20 AM',
        endDate:'19 Oct, 2023',
        notitypeName:' Workflow Name',
        furtherDetailNotitypeName:<div><div className="font-weight-600 tertiary-title">Workflow Description</div><div className="font-weight-400 tertiary-title">Lorem ipsum dolor sit amet consectetur. Eget interdum integer in sed </div></div>,
        notitypeDesc:'Client Name:',
        notitypeNameGot:'UK Workflow ',
        notitypeDescGot:'Jacob Bills',
        actionType:'Assigned By:',
        actionRole:'Manager',
        actionTypeBy:'Jacob Gill',
    },
    {
        id:11,
        notiNotRead:false,
        notiType: 'Access Control Updated',
        notiDesc: 'User access control has been updated',
        startDate:'04:20 AM',
        endDate:'19 Oct, 2023',
        notitypeName:'User Name:',
        furtherDetailNotitypeName:'User Role : Manager ',
        notitypeDesc:'Status:',
        notitypeNameGot:'Clarke Watson',
        notitypeDescGot:'Active',
        actionType:'Updated By:',
        actionRole:'Admin',
        actionTypeBy:'John Doe',
    },
]